import { useState } from "react";
import { hasRichContent } from "../utils/richText";

export const ServiceItemCard = ({ item }) => {
  const normalized = typeof item === "string" ? { title: item } : item;
  const { title, description, images = [] } = normalized;
  const [index, setIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const hasImages = images.length > 0;
  const hasDescription = hasRichContent(description);
  const isRich = hasImages || hasDescription;

  const step = (delta, e) => {
    e?.stopPropagation();
    setIndex((prev) => (prev + delta + images.length) % images.length);
  };

  const goTo = (i, e) => {
    e?.stopPropagation();
    setIndex(i);
  };

  return (
    <div className={`service-card ${isRich ? "service-card--rich" : "service-card--plain"}`}>
      <div className="service-card__body">
        <h4 className="service-card__title">{title}</h4>
        {hasDescription ? (
          <div className="service-card__desc" dangerouslySetInnerHTML={{ __html: description }} />
        ) : null}
      </div>

      {hasImages ? (
        <div className="service-card__media" onClick={() => setLightboxOpen(true)}>
          <img src={images[index]} alt={title} loading="lazy" />
          {images.length > 1 ? (
            <>
              <button
                type="button"
                className="service-card__nav service-card__nav--prev"
                onClick={(e) => step(-1, e)}
                aria-label="Önceki görsel"
              >
                ‹
              </button>
              <button
                type="button"
                className="service-card__nav service-card__nav--next"
                onClick={(e) => step(1, e)}
                aria-label="Sonraki görsel"
              >
                ›
              </button>
              <div className="service-card__dots">
                {images.map((_, i) => (
                  <span
                    key={i}
                    className={`service-card__dot ${i === index ? "is-active" : ""}`}
                    onClick={(e) => goTo(i, e)}
                  />
                ))}
              </div>
            </>
          ) : null}
        </div>
      ) : null}

      {lightboxOpen ? (
        <div className="service-lightbox" onClick={() => setLightboxOpen(false)}>
          <button
            type="button"
            className="service-lightbox__close"
            onClick={() => setLightboxOpen(false)}
            aria-label="Kapat"
          >
            ×
          </button>
          <img
            src={images[index]}
            alt={title}
            className="service-lightbox__img"
            onClick={(e) => e.stopPropagation()}
          />
          {images.length > 1 ? (
            <>
              <button
                type="button"
                className="service-lightbox__nav service-lightbox__nav--prev"
                onClick={(e) => step(-1, e)}
                aria-label="Önceki görsel"
              >
                ‹
              </button>
              <button
                type="button"
                className="service-lightbox__nav service-lightbox__nav--next"
                onClick={(e) => step(1, e)}
                aria-label="Sonraki görsel"
              >
                ›
              </button>
            </>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};
